export const urlRegExp =
  /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

export const urlLikeRegExp = /^https?:\//;
